import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MeetingTypesService {

  constructor(private http: HttpClient) { }

  getData(postData: any, page: any, perPage?: number): Observable<any[]> {
    return this.http.post<any[]>(`${environment.yiiUrl}meeting-types/search-meeting-types?expand=agency_data&page=`
     + page + `&per-page=${perPage}`, postData, { observe: 'response' as 'body' })
    .pipe(map(data => {
      return data;
  }));
  }

  createData(data: any): Observable<object> {
    return this.http.post(`${environment.yiiUrl}meeting-types`, data);
  }

  updateData(data: any): Observable<object> {
    return this.http.put(`${environment.yiiUrl}meeting-types/${data._id}`, data);
  }

  deleteData(_id: any, createdBy: any): Observable<any> {
    return this.http.delete(`${environment.yiiUrl}meeting-types/${_id}?created_by=${createdBy}`);
  }
  getModel(): Observable<object> {
    return this.http.get<any>(`${environment.yiiUrl}agencies/get-exclusions?model=meetingtypes`);
  }

  updateModel(data: any): Observable<object> {
    return this.http.post<any>(`${environment.yiiUrl}agencies/model-exclusions`, data);
  }

  getAllModel(): Observable<object> {
    return this.http.get<any>(`${environment.yiiUrl}agencies/is-all-check?model=meetingtypes`);
  }

  updateAllModel(data: any): Observable<object> {
    return this.http.post<any>(`${environment.yiiUrl}agencies/model-all-exclusions`, data);
  }
}
